import { CountUp } from "countup.js";
import { animate, inView, stagger } from "motion";
import Swiper from "swiper";
import { A11y, Autoplay } from "swiper/modules";

const runCounter = (el) => {
  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

export default {
  init: () => {
    document.querySelectorAll(".measurements-slider").forEach((el) => {
      const container = el.querySelector(".swiper");
      const numSlides = el.querySelectorAll(".swiper-slide").length;

      if (numSlides > 1) {
        new Swiper(container, {
          modules: [A11y, Autoplay],
          autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
          },
          loop: true,
          speed: 1000,
          slidesPerView: "auto",
        });
      }

      inView(
        el,
        () => {
          const items = el.querySelectorAll(".measurement-item");
          const els = el.querySelectorAll("[data-counter]");
          els.forEach((counter) => runCounter(counter));

          animate(
            items,
            { opacity: 1, transform: "translate3d(0, 0, 0)" },
            {
              duration: 0.8,
              delay: stagger(0.2),
            },
          );
        },
        {
          margin: "0px 0px -25% 0px",
        },
      );
    });
  },
};
